export default "__VITE_PUBLIC_ASSET__fe81344d__"